import { API_URL, API_PATH_AUTH_REFRESH, UNAUTHORIZED_STATUS_CODE, UNAUTHORIZED_MESSAGE, FETCH_ERROR_MESSAGE } from '../constants/server';

export const parseJsonResponse = async (response) => {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
};

export const checkResponse = (resBody) => {
  if (resBody && resBody.statusCode === UNAUTHORIZED_STATUS_CODE && resBody.message === UNAUTHORIZED_MESSAGE) {
    return { error: null, data: null };
  }
  if (resBody && resBody.statusCode >= 400) {
    throw new Error(resBody.message || FETCH_ERROR_MESSAGE);
  }
  return { error: null, data: resBody };
};

export const fetchDefaultOptions = {
  headers: { 'Content-Type': 'application/json' },
  credentials: 'include',
  referrerPolicy: 'no-referrer',
  mode: 'cors',
  cache: 'no-cache',
};

export const fetchRequest = async (url, method, body) => {
  const options = { ...fetchDefaultOptions };
  if (method) {
    options.method = method;
  }
  if (body) {
    options.body = body;
  }

  const response = await fetch(url, options);
  const responseBody = await parseJsonResponse(response);

  if (responseBody && responseBody.statusCode === UNAUTHORIZED_STATUS_CODE && responseBody.message === UNAUTHORIZED_MESSAGE) {
    const urlRefresh = `${API_URL}${API_PATH_AUTH_REFRESH}`;
    const optionsRefresh = { ...fetchDefaultOptions };
    optionsRefresh.method = 'POST';
    optionsRefresh.body = JSON.stringify({});

    await fetch(urlRefresh, optionsRefresh);

    const responseRetry = await fetch(url, options);
    const responseRetryBody = await parseJsonResponse(responseRetry);

    return checkResponse(responseRetryBody);
  }

  return checkResponse(responseBody);
};
